import actionTypes from './types'
/**
 * Add laps; laps of another contest replace the current ones
 * @param {Array<Object>} rows laps from the API
 * @param {Object|null} contest contest the laps belong to
 * @returns {Object} action
 */
export const setData = ( rows = [], contest = null ) => ( {
  type: actionTypes.SET_DATA,
  payload: { rows, contest }
} )

export const resetData = () => ( {
  type: actionTypes.RESET_DATA
} )


